import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TParticipation } from '../api-ducks/participation-details-duck/types-participation-details';

const initialState: TParticipation | null = null;

const participationDetailsDuck = createSlice({
  name: 'participationDetails',
  initialState: initialState as TParticipation | null,
  reducers: {
    setParticipationDetails: (state, action: PayloadAction<TParticipation | null>) => action.payload,
  },
});

export const { setParticipationDetails } = participationDetailsDuck.actions;
export default participationDetailsDuck.reducer;
